// A page just opened: its cards rise in one after another (top to bottom, left to right) and list rows slide in
// from the left, one every 0.1 s, like Danat Ledger. Only what is on screen; nothing waits for it.
const CARDS = '.panel, .table-wrap, .prj-kpis > button, .fin-card, .dash-card, .kpi-tile';
const ROWS = '.list > li';

const done = new WeakSet<Element>();

/** Called a few times in the first moments after a page opens: what has appeared since is played once. */
export function staggerPage(root: HTMLElement | null) {
  if (!root || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
  const h = window.innerHeight;
  const onScreen = (el: Element) => { const r = el.getBoundingClientRect(); return r.height > 0 && r.top < h && r.bottom > 0; };
  const cards = [...root.querySelectorAll<HTMLElement>(CARDS)].filter((el) => onScreen(el) && !el.parentElement?.closest(CARDS));
  cards.sort((a, b) => { const ra = a.getBoundingClientRect(); const rb = b.getBoundingClientRect(); return Math.round(ra.top / 40) - Math.round(rb.top / 40) || ra.left - rb.left; });
  cards.slice(0, 10).forEach((el, i) => play(el, 'm-card-rise', 60 + i * 60));
  // Rows: per list, the first few.
  const lists = new Set([...root.querySelectorAll<HTMLElement>(ROWS)].filter(onScreen).map((li) => li.parentElement!));
  lists.forEach((ul) => [...ul.children].filter(onScreen).slice(0, 6).forEach((li, i) => play(li as HTMLElement, 'm-row-in', 160 + i * 90)));
}

function play(el: HTMLElement, name: string, delay: number) {
  if (done.has(el)) return;
  done.add(el);
  el.animate?.(
    name === 'm-card-rise'
      ? [{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'none' }]
      : [{ opacity: 0, transform: 'translateX(-16px)' }, { opacity: 1, transform: 'none' }],
    { duration: name === 'm-card-rise' ? 420 : 320, delay, easing: 'cubic-bezier(.2, .8, .2, 1)', fill: 'backwards' },
  );
}

/** The page shown fades up and blurs away (0.18 s) before the next one opens. */
export function leavePage(go: () => void) {
  const main = document.querySelector<HTMLElement>('.content');
  if (!main || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) { go(); return; }
  main.classList.add('m-leaving');
  window.setTimeout(() => { main.classList.remove('m-leaving'); go(); }, 180);
}
